package gr.tech.pdfgenerator.models

import gr.tech.pdfgenerator.util.INPUTS
import kotlinx.serialization.Serializable

@Serializable
data class MSAInputsDTO(
    var addressOverwriteCheck: Boolean = false,
    var addressOverwrite: String = "",
    var stateOverwrite: String = "",
    var cityOverwrite: String = "",
    var zipOverwrite: String = "",

    var utilityProgram: String = "",
    var authorizerName: String = "",
    var projectDescription: String = INPUTS.MSA.MsaProjectDefaultDescription,
    var deliverableList: List<MSADeliverableDTO> = mutableListOf(),
    var efficiencyMeasureList: List<String> = mutableListOf()
) {
    override fun toString(): String {
        return """
            |MSAInputsDTO(
            |  Rebate Program      : $utilityProgram
            |  Authorizer Name     : $authorizerName
            |  Project Description : $projectDescription
            Deliverables        : ${if (deliverableList.isEmpty()) "None" else ""}
            |${deliverableList.joinToString("\n") { it.toString().prependIndent("  |    ") }}
            |)
        """.trimMargin()
    }
}

@Serializable
data class MSADeliverableDTO(
    var deliverable: String = "",
    var phase: String = "",
    var description: String = "",
    var dueDate: String = "",
) {
    override fun toString(): String {
        return """
            |- Deliverable : $deliverable
            |  Phase       : $phase
            |  Description : $description
            |  Due Date    : $dueDate
        """.trimMargin()
    }
}